export let IntegrationProductType;
(function (IntegrationProductType) {
  IntegrationProductType["APP"] = "APP";
  IntegrationProductType["AGENT"] = "AGENT";
  IntegrationProductType["CONNECTOR"] = "CONNECTOR";
  IntegrationProductType["WORKFLOW_TEMPLATE"] = "WORKFLOW_TEMPLATE";
  IntegrationProductType["UNKNOWN"] = "UNKNOWN";
})(IntegrationProductType || (IntegrationProductType = {}));